module.exports = __webpack_public_path__ + "img/team-map-12.6b10070a.png";